import React from 'react';
import { inject } from 'mobx-react';

import { SectionLayout } from 'layouts/section';
import { CardBackgroundComponent as Card } from 'components/cards';
import { DownloadComponent as Download } from 'components/download';

import transfer from 'static/documents/überweisung.pdf';
import catQuestionnaire from 'static/documents/fragebogenkatze.pdf';
import dogQuestionnaire from 'static/documents/fragebogenhund.pdf';
import background from 'static/images/kitten.jpg';
import styles from './consultation-page.styles.scss';


@inject('analyticsStore')
export class ConsultationPage extends React.Component {
  componentDidMount() {
    this.props.analyticsStore.pageview('/consultation');
  }

  render() {
    return (
      <div className={styles.Consultation}>
        <SectionLayout background={background}>
          <Card className={styles.Card}>
            <h1>Konsultation</h1>
            <p>
              Auch in tierärztlicher Praxis werden vermehrt Tiere mit Verhaltensauffälligkeiten vorgestellt. Gerne biete ich in Ihrer Praxis eine verhaltenstherapeutische Sprechstunde an oder übernehme einzelne Fälle. Eine gründliche Allgemeinuntersuchung wird bei jeder Konsultation durchgeführt. Wichtig ist mir vorab eine Abklärung möglicher organischer Ursachen, denn bestimmte Erkrankungen, wie Schilddrüsenüber- oder unterfunktion können Verhaltensprobleme verursachen oder verschlimmern.
            </p>
          </Card>
        </SectionLayout>

        <SectionLayout>
          <h2>Liebe Kollegen,</h2>
          <p>
            als Überweisungspraxis für Tierverhaltensmedizin wünsche ich uns eine angenehme und erfolgreiche Zusammenarbeit. Angeboten wird eine mobile tierärztliche Verhaltenstherapie, gerne wird diese auch in Ihrer Praxis durchgeführt.
          </p>
          <p>
            Hier haben Sie die Möglichkeit ein Überweisungsformular abzurufen, mit dem Sie uns Vorbefunde und - behandlungen mitteilen können. Ausserdem kann vorab schon der Tierbesitzer das Anamneseformular ausfüllen. Gern sende ich Ihnen diese Formulare auch zu.
          </p>
          <p>
            Nach der Diagnosestellung wird Ihnen die voraussichtliche Dauer der Behandlung mitgeteilt und nach Therapieabschluss erhalten Sie eine ausführliche schriftliche und/oder telefonische Rücküberweisung. Selbstverständlich stehe ich Ihnen für Fragen immer zur Verfügung.
          </p>
        </SectionLayout>

        <SectionLayout>
          <h2>Downloads</h2>
          <div className={styles.Downloads}>
            <Download className={styles.Download} src={transfer} />
            <Download className={styles.Download} src={catQuestionnaire} />
            <Download className={styles.Download} src={dogQuestionnaire} />
          </div>
        </SectionLayout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/consultation/consultation.page.jsx